// var baseurl = 'http://123.57.49.81/'
var api = {
    baseurl: 'https://ggy.hqzcb.com',
    demo:{
        about_us: 'api/demo/about_us',//关于我们
        notice_list: 'api/demo/notice_list',//园区通知/要闻
        notice_detail: 'api/demo/notice_detail',//通知/要闻详情
        notice_cat: 'api/demo/notice_cat',//通知/要闻分类
        config: 'api/demo/config',//配置接口
        goods_company: 'api/demo/goods_company',//优秀企业
        introduce_us: 'api/demo/introduce_us',//园区简介
        public_list: 'api/demo/public_list',//公共服务
        public_detail: 'api/demo/public_detail',//服务详情
        data_show: 'api/demo/data_show',//数据展示
        company_list: 'api/demo/company_list',//获取楼层企业
        building: 'api/demo/building',//楼层信息
    },
    index: {
        get_city_area: 'api/index/get_city_area',//获取市和区
        informationList: 'api/index/informationList',//政策资讯（申报）
        noticeList: 'api/index/noticeList',//政策资讯（公告）
        informationDetail: 'api/index/informationDetail',//申报详情
        noticeDetail: 'api/index/noticeDetail',//公告详情
        typeList: 'api/index/typeList',//政策分类
        depotList: 'api/index/depotList',//政策库
        depotDetail: 'api/index/depotDetail',//政策详情
        get_first_category: 'api/index/get_first_category',//企业库分类-左边
        get_second_category: 'api/index/get_second_category',//企业库分类-右边
        get_policy_year: 'api/index/get_policy_year',//分类年份
        get_policy_name: 'api/index/get_policy_name',//获取政策名称
        get_enterprise_list: 'api/index/get_enterprise_list',//企业列表
        enterprise_detail: 'api/index/enterprise_detail',//企业详情
        enterprise_support: 'api/index/enterprise_support',//已获政策
        shareholder_list: 'api/index/shareholder_list',//股东信息
        majorpeople_list: 'api/index/majorpeople_list',//主要人员
        change_list: 'api/index/change_list',//变更记录
        qualification_list: 'api/index/qualification_list',//资质证书
        brand_list: 'api/index/brand_list',//商标信息
        patent_list: 'api/index/patent_list',//专利信息
        softright_list: 'api/index/softright_list',//软件著作权
        copyright_list: 'api/index/copyright_list',//作品著作权
    },
    newapi: {
        enterprise_detailpc: 'api/index/enterprise_detail', // 新企业详情
        enterprise_support: 'api/index/enterprise_support', //
    },
    interfacenew: {
        get_number: 'api/interfacenew/get_number', // 数量展示
        // 企业数据
        contract_list: 'api/interfacenew/contract_list', // 联系方式
        contract_count: 'api/interfacenew/contract_count', // 联系方式数量
        person_list: 'api/interfacenew/person_list', // 人员信息
        tender_list: 'api/interfacenew/tender_list', // 招投标
        tender_count: 'api/interfacenew/tender_count', // 招投标数量
        jyabnormal_list: 'api/interfacenew/jyabnormal_list', // 经营异常
        jypunish_list: 'api/interfacenew/jypunish_list', // 行政处罚
        document_list: 'api/interfacenew/document_list', // 文书列表
        courtnotice_list: 'api/interfacenew/courtnotice_list', // 法院公告
        opennotice_list: 'api/interfacenew/opennotice_list', // 开庭公告
        filing_list: 'api/interfacenew/filing_list', // 立案信息
    },
    companydata: {
        shareholder_list: 'api/index/shareholder_list', // 股东信息
        brand_list: 'api/index/brand_list', // 资质资格列表
        patent_list: 'api/index/patent_list', // 专利信息
        softright_list: 'api/index/softright_list', // 软件著作权
        copyright_list: 'api/index/copyright_list', // 作品著作权
        qualification_list: 'api/index/qualification_list', // 资质证书
    }
}
export default {
    api: api
}



// WEBPACK FOOTER //
// ./src/api/api.js